import { css } from "@emotion/react";
import { breakpoints } from "shared";

const hero = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  opacity: 0;
  margin-top: 40px;
  display: flex;
  align-items: flex-end;
  animation: 0.6s fadeIn 0.6s forwards ease-out;
  border-radius: 8px;

  h4 {
    position: absolute;
    font-style: italic;
    font-weight: 200;
    top: 12px;
    left: 50%;
    width: 60%;
    text-align: center;
    transform: translateX(-50%);
  }

  @media ${breakpoints.fromMed} {
    display: flex;
    align: flex-start;
  }

  transition: background-position-x 0.2s ease-out;
`;

const heroImage = css`
  height: 500px;
  width: 100%;
  object-fit: cover;
  object-position: 0% 40%;
  border-radius: 8px;

  @media ${breakpoints.toMed} {
    object-position: 40% 40%;
    height: 300px;
  }
`;

const quote = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  font-weight: 100;
  opacity: 0;
  margin: 20px 0;
  animation: 0.6s fadeIn 0.4s forwards ease-out;
  text-align: center;

  p {
    margin-top: 8px;
    text-align: right;
  }
`;

const rest = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  opacity: 0;
  animation: 0.6s fadeIn 1s forwards ease-out;
`;

export default { hero, heroImage, quote, rest };
